<template>
	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-bind:style="{ width: screenWidth+'px', height: screenHeight + 'px' }" v-show="pop_show">
		<span class="pop_tan_bg" @click="closeshow()"></span>

		<div id="pop_bodyup" class="pop_tan_content">
			<!-- 动态查询区生成 -->
			<div class="pop_children" v-loading="element_loading" element-loading-text="拼命加载中......"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="pop_head_close">
					<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
				</div>
				<div>
					<h5>费用&nbsp;&nbsp;结算:</h5>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="refresh_data()">
							刷新
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('new')">
							新增结算单
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('add')">
							保存
						</button>&nbsp;
						<button class="pre_btn_ok btn_del" @click="fun_upd('del')">
							删除
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('sub')">
							提交
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('bad')">
							作废
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_file_list()">
							附件管理
						</button>
					</div>
					<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
						<h3 class="red">
							{{sheet_flag}}
						</h3>
					</div>

				</div>

				<div class="content_edit edit-body">
					<div class="content_edit_item tab-border">
						<div class="content_edit_item tab-row">结算中</div>
						<div id="pre_tab" class="content_edit_item tab-row">
							<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header">
									<td>序号</td>
									<td>单号</td>
									<td>开始日期</td>
									<td>截止日期</td>
									<td>客户</td>
								</tr>
								<tr class="tab-body" :id="'pay_'+item.row_num" v-for="item in list_pass_m"
									@click="fun_pay_sel(item)">
									<!-- <a href="#"> -->
									<td>{{item.row_num}}</td>
									<td>{{item.sheet_no}}</td>
									<td>{{item.s_date}}</td>
									<td>{{item.e_date}}</td>
									<td v-on:mousemove="show_detaildata($event, item.c_name, '1')"
										v-on:mouseout="noshow_detaildata">
										<a href="#">{{item.c_name}}</a>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="content_edit_item tab-border">

						<div class="content_edit_item edit-row" v-for="(r,d) in max_row" :key="d">

							<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm"
								:key="index">
								<!-- {{handleImportView(item)}} -->

								<component ref="editfatherzj" :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_edit">
								</component>
							</div>
						</div>

						<div class="content_edit" v-show="file_show">
							<div class="content_edit_item">
								<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;</span>
							</div>
						</div>

						<div class="content_edit_item edit-area">
							<div class="content_edit_item tab-row">
								<label class="pre-inline">结算日期:</label>
								<el-date-picker v-model="pay_date" type="date" class="long1" value-format="yyyy-MM-dd"
									placeholder="选择日期">
								</el-date-picker>
								&nbsp;&nbsp;&nbsp;&nbsp;
								<label class="pre-inline">结算金额:</label>
								<input type="number" class="long1" v-model="pay_amount" />
								&nbsp;&nbsp;&nbsp;&nbsp;
								<label>备注:</label>
								<input type="text" class="long1" v-model="pay_note" @keyup.enter="fun_d_upd('add')" />
								&nbsp;&nbsp;&nbsp;&nbsp;
								<button class="pre_btn_ok" @click="fun_d_upd('add')">
									保存
								</button>
								&nbsp;&nbsp;&nbsp;&nbsp;
								<button class="pre_btn_ok" @click="fun_d_upd('delall')">
									全删
								</button>
							</div>
							<div class="edit-row edit-tab">
								<!-- 已经选择的 短途运单 -->
								<div class="content_edit_item tab-row">
									<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
										<tr class="tab_header">
											<td>序号</td>
											<td>单号</td>
											<td>日期</td>
											<td>起点</td>
											<td>终点</td>
											<td>车牌</td>
											<td>司机</td>
											<td>运费</td>
											<td>操作</td>
										</tr>
										<tr class="tab-body" :id="'selok_'+item.row_num" v-for="item in list_pass_selok"
											@click="fun_d1_sel(item,'edit')">
											<!-- <a href="#"> -->
											<td>{{item.row_num}}</td>
											<td>{{item.sheet_no}}</td>
											<td>{{item.s_date}}</td>
											<td>{{item.s_addr}}</td>
											<td>{{item.e_addr}}</td>
											<td>{{item.car_no}}</td>
											<td>{{item.driver}}</td>
											<td>{{item.yf_amount}}</td>
											<td><span @click="fun_d1_sel(item,'_del')">
													<i class="iconfont icon-shanchu"></i>删除
												</span></td>

										</tr>
									</table>
								</div>
								<!-- 已经录入的结算明细 -->
								<div class="content_edit_item tab-row">
									<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
										<tr class="tab_header">
											<td>序号</td>
											<td>单号</td>
											<td>结算日期</td>
											<td>结算金额</td>
											<td>备注</td>
											<td>编辑</td>
										</tr>
										<tr class="tab-body" :id="'selpay_'+item.row_num" v-for="item in list_pass_d"
											@click="fun_d_sel('edit',item)">
											<!-- <a href="#"> -->
											<td>{{item.row_num}}</td>
											<td>{{item.sheet_no}}</td>
											<td>{{item.pay_date}}</td>
											<td>{{item.pay_amount}}</td>
											<td>{{item.note}}</td>
											<td><span @click="fun_d_sel('_del',item)">
													<i class="iconfont icon-shanchu"></i>删除
												</span></td>
										</tr>
									</table>
								</div>

							</div>
						</div>
					</div>
					<div class="content_edit_item tab-border">
						<div class="content_edit_item tab-row">待结算列表</div>
						<div class="content_edit_item tab-row">
							<label class="pre-inline">开始日期:</label>
							<el-date-picker v-model="s_date" type="date" class="long1" value-format="yyyy-MM-dd"
								placeholder="选择日期">
							</el-date-picker>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<label>客户:</label>
							<input type="text" class="long2" v-model="c_name" @keyup.enter="fun_d_upd('add')" />

						</div>
						<div class="content_edit_item tab-row">
							<button class="pre_btn_ok" @click="load_list_sel_no()">
								筛选
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<button class="pre_btn_ok" @click="fun_all_put()">
								全选
							</button>
						</div>
						<div id="pre_tab" class="content_edit_item tab-row">
							<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header">
									<td>序号</td>
									<td>单号</td>
									<td>开始日期</td>
									<td>起点</td>
									<td>终点</td>
									<td>客户</td>
									<td>车牌</td>
									<td>司机</td>
								</tr>
								<tr class="tab-body" :id="'selno_'+item.row_num" v-for="item in list_pass_selno"
									@click="fun_d1_sel(item,'_add')">
									<!-- <a href="#"> -->
									<td>{{item.row_num}}</td>
									<td>{{item.sheet_no}}</td>
									<td>{{item.s_date}}</td>
									<td>{{item.s_addr}}</td>
									<td>{{item.e_addr}}</td>
									<td>{{item.c_name}}</td>
									<td>{{item.car_no}}</td>
									<td>{{item.driver}}</td>
								</tr>
							</table>
						</div>
					</div>

				</div>



			</div>
		</div>
		<div id="pre_msg_data_wz" style="display:none;"></div>

		<prefilelist ref="myfilelist" @filelist-event="refresh_data" />
	</div>
</template>

<script>
	/* 
	维修弹窗。。。。。。。
	*/
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		JsonStr
	} from '@/utils/method.js';
	import {
		GetShort,
		BackSpecial,
		GetRandom
	} from "@/utils/localstore.js";

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete,
		ReplaceAll
	} from '@/utils/method.js';

	export default {
		name: "pre_tan_car_over",
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				row_id: '',
				sys_date: '',
				sheet_no: '',
				sheet_flag: '',
				screenWidth: '',
				screenHeight: '',
				sel_action: '',
				upd_action: '',

				max_row: [],
				list_m: '',
				parm: [],

				file_show: false,
				file_name: '',

				list_pass_m: [], //结算账单
				list_pass_d: [], //结算账单明细
				list_pass_selok: [], //待选账单
				list_pass_selno: [],

				pay_id: '',
				pay_date: '',
				pay_amount: 0,
				pay_note: '',
				pay_sys_date: '',

				// 组件按钮权限获取
				filelist_control: {},
				sel_from: 'm',
				filelist_id: '',
				filelist_tf: [],

				// 待选参数
				s_date: '',
				c_name: '',


			};
		},
		methods: {
			load_power_filelist: function() {
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Method_EasySelect('filelist_power_check', 'trans_short', r)
				).then(res => {
					res = JSON.parse(res);
					let o = {};
					o = res.data.data[0];
					o.msg = res.data.msg;
					this.filelist_control = o;
				});

			},
			fun_file_list: function() {
				if (typeof(this.sheet_no) === 'undefined') {
					// console.log('正在校验附件集组件操作权限,请等待');
					this.$message({
						message: '请先选择一条数据,再操作附件集合!',
						type: 'warning'
					});
					return;
				}

				console.log('当前附件集组件权限', this.filelist_control);
				if (typeof(this.filelist_control.isok) === 'undefined') {
					// console.log('正在校验附件集组件操作权限,请等待');
					this.$message({
						message: '正在校验附件集组件操作权限,请等待',
						type: 'warning'
					});
					return;
				}
				if (this.filelist_control.isok == '0') {
					// console.log('您没有附件集组件的操作权限!');
					this.$message({
						message: this.filelist_control.msg,
						type: 'warning'
					});
					return;
				}

				let p = {};
				p.title = '结算附件';
				p.file_action = 'filemore';
				p.p1 = 'ys';
				p.p2 = 'dt';
				p.p3 = '';

				p.file_src = '';
				p.file_url = '';

				p.sheet_no = this.sheet_no;
				p.row_id = this.filelist_id;
				p.sheet_flag = this.sheet_flag;
				p.filelist = this.filelist_tf;
				p.sel_from = this.sel_from;

				p.file_up = this.filelist_control.fileup;
				p.file_look = this.filelist_control.filelook;
				p.file_del = this.filelist_control.filedel;


				this.$refs['myfilelist'].load_data(p);
			},
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			chang_style: function() {
				this.screenWidth = $(window).width();
				this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
			},
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_tan_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_tan_bg").fadeIn("3000");
				$(".pop_tan_content").fadeIn("3000");
				this.chang_style();
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_tan_bg").fadeOut("3000");
				$(".pop_tan_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			load_data: async function(res) {
				// console.log('初始参数', res);

				let r = res;
				// 清理缓存
				this.row_id = '';
				this.sel_action = 'exp_dtys_trans_short_over_m';
				this.upd_action = '_dtys_trans_short_over_m';

				this.title = '';
				this.sheet_no = '';
				// this.sheet_flag=r.flag;
				this.parm = []; //主单保存数据
				this.parm = [{
						"name": "单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"x": "1",
						"r": "1"
					},
					{
						"name": "开始日期",
						"val": "",
						"key": "s_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "截止日期",
						"val": "",
						"key": "e_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "客户",
						"val": "",
						"key": "c_name",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_company",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},

					{
						"name": "经办人",
						"val": "",
						"key": "u_name",
						"type": "select",
						"class": "long1",
						"sel_action": "data_alluser",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"

					},
					{
						"name": "应结总额",
						"val": "",
						"key": "amount_all",
						"type": "label",
						"class": "long1",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "已结总额",
						"val": "",
						"key": "amount_ok",
						"type": "label",
						"class": "long1",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "未结总额",
						"val": "",
						"key": "amount_no",
						"type": "label",
						"class": "long1",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "4"
					},

					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "3"
					}
				];

				/*初始化 select 数据 start*/


				for (let i = 0; i < this.parm.length; i++) {
					switch (this.parm[i].type) {
						case 'select':
							let t = [];
							let t_sel_action = '';
							t_sel_action = this.parm[i].sel_action;
							if (typeof(t_sel_action) !== 'undefined' && t_sel_action != '') {
								let res = await this.loadClass(t_sel_action);
								if (res.status == '1') {
									t = res.data;
									this.parm[i].list = t;
								}
								// console.log(res);

							}
							break;
						case 'switch':
							let t_in_action = '',
								t_out_action = '';
							t_in_action = this.parm[i].action_in;
							t_out_action = this.parm[i].action_out;
							if (typeof(t_in_action) !== 'undefined' && t_in_action != '') {
								let res_in = await this.loadClass(t_in_action);
								// console.log('收入', res_in);
								if (res_in.status == '1') {
									this.parm[i].list_in = res_in.data;
								} else {
									this.parm[i].list_in = [];
								}
							}

							if (typeof(t_out_action) !== 'undefined' && t_out_action != '') {
								let res_out = await this.loadClass(t_out_action);
								// console.log('支出', res_out)
								if (res_out.status == '1') {
									this.parm[i].list_out = res_out.data;
								} else {
									this.parm[i].list_out = [];
								}
							}

							break;
					}

				}
				this.max_row = [];
				for (let i = 1; i <= this.parm.length; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.refresh_data();
				this.load_power_filelist();
			},
			refresh_view_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);

				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {

						if (this.parm[i].type == 'selectnew' || this.parm[i].type == 'select' || this.parm[
								i].type ==
							'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;

							if (String(d.sel_more).indexOf('_to') > 0) {
								let sel_key = String(d.sel_more).substring(0, 1);
								// console.log('编辑联动查询关键字=' + sel_key);

								for (let j = 0; j < this.parm.length; j++) {
									if (this.parm[j].sel_more == sel_key && typeof(this.parm[j]
											.sel_action) !==
										'undefined' && this
										.parm[j].sel_action != '') {

										this.parm[j].list = [];
										this.parm[j].val = '';
										this.parm[j].sel_name = '';

										let res = await this.loadClass(this.parm[j].sel_action, d.val);
										if (res.status == '1') {
											this.parm[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.editfatherzj[j].refresh_select(JSON.stringify(this.parm[
											j]));
									}
								}
							}

							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}

						break;
					}
				}
				// console.log('编辑更新后', this.parm);

				if (type == 'save') {
					this.fun_upd('add');
				}
			},

			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			refresh_data: function() {

				this.pay_id = 0;
				this.pay_date = '';
				this.pay_amount = 0;
				this.pay_note = '';
				this.pay_sys_date = '';

				this.list_pass_m = []; //结算账单
				this.list_pass_d = []; //结算账单明细
				this.list_pass_selok = []; //已选短途运单
				this.list_pass_selno = []; //待选短途运单

				this.load_list_m(); // 加载结算账单

			},
			load_list_m: function() {
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				// 加载结算账单
				this.$post(
					api.http_method, Sel_page_and_length('exp_dtys_pay_m_over', 1, 100, this.sheet_no, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0 && res[0].length > 0) {
						let arr = res[0];
						// console.log(arr);
						this.list_pass_m = [];
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_pass_m.push(o);
						}
						// console.log(this.list_pass_m);
						if (typeof(this.sheet_no) !== 'undefined' && this.sheet_no != '') {
							for (let i = 0; i < this.list_pass_m.length; i++) {
								if (this.list_pass_m[i].sheet_no == this.sheet_no) {
									this.fun_pay_sel(this.list_pass_m[i]);
									break;
								}
							}
						}
						this.load_list_sel_no(); //加载待选短途运单
					} else {
						this.$message({
							message: '没有查询到未完成的结算账单!',
							type: 'warning'
						});
					}
				});
			},
			load_list_d: function() {
				this.element_loading = true;
				this.list_pass_d = [];
				let r = (Math.random() + '').substring(0, 8);
				if (typeof(this.sheet_no) === 'undefined' || this.sheet_no == '') {
					return;
					// 加载当前选择结算账单的 结算明细
				}
				this.$post(
					api.http_method, Sel_page_and_length('exp_dtys_pay_d_over', 1, 100, this.sheet_no, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0 && res[0].length > 0) {
						let arr = res[0];
						// console.log(item);

						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_pass_d.push(o);
						}
						console.log(this.list_pass_d);


					} else {
						this.$message({
							message: '没有查询到结算明细!',
							type: 'warning'
						});
					}
				});
			},
			load_list_sel_ok: function() {
				this.element_loading = true;
				this.list_pass_selok = [];
				let r = (Math.random() + '').substring(0, 8);
				if (typeof(this.sheet_no) === 'undefined' || this.sheet_no == '') {
					return;
					// 加载当前选择结算账单的 结算明细
				}
				this.$post(
					api.http_method, Sel_page_and_length('exp_dtys_pay_d_sel_ok', 1, 100, this.sheet_no, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0 && res[0].length > 0) {
						let arr = res[0];
						// console.log(item);

						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_pass_selok.push(o);
						}
						// console.log(this.list_pass_selok);


					} else {
						this.$message({
							message: '没有查询到已选短途运单!',
							type: 'warning'
						});
					}
				});
			},
			load_list_sel_no: function() {
				this.element_loading = true;
				this.list_pass_selno = [];
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_dtys_pay_d_sel_no', 1, 100, this.s_date, this.c_name,
						r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						let arr = res[0];
						// console.log(item);

						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_pass_selno.push(o);
						}
						// console.log(this.list_pass_selno);
					} else {
						this.$message({
							message: '没有查询到待选短途运单!',
							type: 'warning'
						});
					}
				});
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type);

				if (type == 'upd' || type == 'del' || type == 'sub' || type == 'bad') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}

				// 数据格式检查
				// console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type ==
							'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[
									i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i]
										.sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[
									i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list) !== 'undefined' && this
								.parm[i].list.length > 0) {
								temp = '0';
								let tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								// console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}


				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common(this.upd_action + '_' + type, this.row_id, this
					.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.load_list_m(); //加载结算账单
						this.load_list_d(); //加载结算明细
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			fun_pay_sel: function(item) {
				// console.log('结算中', item);
				this.sel_from = 'm';
				for (let d in item) {
					// console.log(d + '=' + item[d]);
					switch (d) {
						case 'id':
							this.row_id = item[d];
							this.filelist_id = item[d];
							break;
						case 'flag':
							this.sheet_flag = item[d];
							break;
						case 'sys_date':
							this.sys_date = item[d];
							break;
						case 'sheet_no':
							this.sheet_no = item[d];
							break;
						case 'f_url':
							let tt = JsonStr(item[d]);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[d];
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}

							break;
						case 'f_src':
							this.file_src = item[d];
							break;
						case 'img_list':
							this.filelist_tf = item[d];
							break;
						default:
							break;
					}
				}

				for (let d in item) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == d) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// //console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[d];
							} else {
								this.parm[j].val = item[d];
							}

						}
					}
				}

				for (var i = 0; i < this.list_pass_m.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_pass_m[i].row_num == item.row_num) {
						document.getElementById('pay_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_pass_m[i].row_num % 2 == 0) {
							document.getElementById('pay_' + this.list_pass_m[i].row_num).style.background =
								'#fff';
						} else {
							document.getElementById('pay_' + this.list_pass_m[i].row_num).style.background =
								'#f5f5f5';
						}
					}
				}
				this.load_list_sel_ok(); //加载已经选择的短途运单
				this.load_list_d(); //加载结算明细
			},
			//编辑结算 明细//////////////////////
			fun_d_sel: function(type, item) {
				console.log('结算明细', item);
				this.pay_id = 0;
				this.pay_date = '';
				this.pay_amount = 0;
				this.pay_note = '';
				this.pay_sys_date = '';

				this.pay_id = item.id;
				this.pay_date = item.pay_date;
				this.pay_amount = item.pay_amount;
				this.pay_note = item.note;
				this.pay_sys_date = item.sys_date;

				// 
				this.sel_from = 'd';
				this.filelist_id = item.id;
				this.filelist_tf = item.img_list;


				for (var i = 0; i < this.list_pass_d.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_pass_d[i].row_num == item.row_num) {
						document.getElementById('selpay_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_pass_d[i].row_num % 2 == 0) {
							document.getElementById('selpay_' + this.list_pass_d[i].row_num).style.background =
								'#fff';
						} else {
							document.getElementById('selpay_' + this.list_pass_d[i].row_num).style.background =
								'#f5f5f5';
						}
					}
				}

				if (type == '_del') {
					this.fun_d_upd('del');
				}

			},
			fun_d_upd: function(type) {

				if (typeof(this.sheet_no) == 'undefined' || this.sheet_no == '') {
					this.$message({
						message: '请先新建一个结算单!',
						type: 'warning'
					});
					return;
				}

				let d = [];
				d.push(this.sheet_no)
				d.push(this.pay_date);
				d.push(this.pay_amount);
				d.push(this.pay_note);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('_dtys_trans_short_over_d_' + type, this.pay_id, this.pay_sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.load_list_m(); //加载结算单据主 更新应结金额

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			///////////////////////
			fun_d1_sel: function(item, type) {
				// console.log('待分配', item);
				if (typeof(this.sheet_no) == 'undefined' || this.sheet_no == '') {
					this.$message({
						message: '请先新建一个结算单!',
						type: 'warning'
					});
					return;
				}



				let t_msg = '';
				if (type == '_add') {
					for (var i = 0; i < this.list_pass_selno.length; i++) {
						// console.log(this.data_tab[i]);
						if (this.list_pass_selno[i].row_num == item.row_num) {
							document.getElementById('selno_' + item.row_num).style.background = '#92a4f3';
						} else {
							if (this.list_pass_selno[i].row_num % 2 == 0) {
								document.getElementById('selno_' + this.list_pass_selno[i].row_num).style.background =
									'#fff';
							} else {
								document.getElementById('selno_' + this.list_pass_selno[i].row_num).style.background =
									'#f5f5f5';
							}
						}
					}

					t_msg =
						'<p>确定将单号:<span class="word-red">' + item.sheet_no + '</span></p>' +
						'<p>客户:<span class="word-red">' + item.c_name + '</span>' +
						'从:<span class="word-red">' + item.s_addr + '</span>' +
						'到:<span class="word-red">' + item.e_addr + '</span></p>' +
						'<p>司机:<span class="word-red">' + item.driver + '</span></p>' +
						'<p>车牌:<span class="word-red">' + item.car_no + '</span></p>' +
						'<p>放入结算单!</p>';
				}
				if (type == '_del' || type == 'edit') {
					for (var i = 0; i < this.list_pass_selok.length; i++) {
						// console.log(this.data_tab[i]);
						if (this.list_pass_selok[i].row_num == item.row_num) {
							document.getElementById('selok_' + item.row_num).style.background = '#92a4f3';
						} else {
							if (this.list_pass_selok[i].row_num % 2 == 0) {
								document.getElementById('selok_' + this.list_pass_selok[i].row_num).style.background =
									'#fff';
							} else {
								document.getElementById('selok_' + this.list_pass_selok[i].row_num).style.background =
									'#f5f5f5';
							}
						}
					}

					t_msg =
						'<p>确定将单号:<span class="word-red">' + item.sheet_no + '</span></p>' +
						'<p>客户:<span class="word-red">' + item.c_name + '</span>' +
						'从:<span class="word-red">' + item.s_addr + '</span>' +
						'到:<span class="word-red">' + item.e_addr + '</span></p>' +
						'<p>司机:<span class="word-red">' + item.driver + '</span></p>' +
						'<p>车牌:<span class="word-red">' + item.car_no + '</span></p>' +
						'<p>移出结算单!</p>';
				}

				if (type == '_add' || type == '_del') {
					this.$confirm(t_msg, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).then(() => {
						this.fun_d_put(type, item.id, item.sheet_no, item.sys_date);
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消提交'
						});
					});
				}


			},
			fun_d_put: function(type, temp_id, temp_no, temp_date) {

				let d = [];
				d.push(this.sheet_no)
				d.push(temp_id);
				d.push(temp_no);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('_dtys_put_short' + type, temp_id, temp_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.load_list_m(); //加载结算单据主 更新应结金额
						// this.load_list_sel_ok(); //加载已选短途运单 更新选择明细

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			fun_all_put: async function() {
				for (var i = 0; i < this.list_pass_selno.length; i++) {
					// console.log(this.list_pass_selno[i]);
					let res = await this.fun_d_upd_list('_add', this.list_pass_selno[i].id, this.list_pass_selno[
						i].sheet_no);
					this.$message({
						message: res.msg,
						type: 'success'
					});
				}
				this.load_list_sel_no();
				this.load_list_d(); //加载结算明细1
				this.load_list_sel_ok();
				this.load_list_m(); //加载结算单据主 更新应结金额
			},
			fun_d_upd_list: function(type, from_id, from_no) {
				let that = this;
				let d = [];
				d.push(this.sheet_no)
				d.push(from_id);
				d.push(from_no);

				return new Promise((resolve, reject) => {
					let r = (Math.random() + '').substring(0, 8);
					// console.log(d);
					let temp_data = '';
					temp_data = Method_Common('_dtys_put_short' + type, 0, '', d, r);

					this.$post(
						api.http_method, temp_data
					).then(res => {
						this.element_loading = false;
						res = JSON.parse(res);
						// console.log(res);
						resolve(res.data)


					});

				});
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(item);
				x = that.clientX + 10;
				y = that.clientY - 80;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" +
					x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// //console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText =
						temp_css;
				}
				if (type == "1" && item != '') {
					temp_css +=
						"max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					document.getElementById("pre_msg_data_wz").innerText = BackSpecial(
						item);
					document.getElementById("pre_msg_data_wz").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_msg_data_wz").style.display = 'none';
			},





		}
	};
</script>


<style scoped>
	.tanfile {
		display: -webkit-inline-box;
		max-height: 60vh;
		overflow: auto;
	}

	.pop_tan_bg {
		width: 100%;
		background: #000000;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
		height: 1340px;
		display: none;
		z-index: 9;
	}

	.pop_tan_content {

		height: auto;
		/* background: #faf5f5; */
		background-color: rgb(195, 219, 250);
		position: fixed;
		border-radius: 3px;
		display: none;
		z-index: 10;
		padding: 5px;
		/* overflow: hidden; */

		display: inline-block;
		min-width: 720px;
		/* max-width: 95vw; */
		max-height: 80vh;
		overflow: auto;
	}

	/* .pop_children{
	position: fixed;
	
	z-index: 9999;
} */
	.tab-row {
		display: inline-flex;
		overflow: auto;
		margin: 2px;
		align-items: center;
	}

	.tab-border {

		display: flex;
		flex-direction: column;
		border: 1px solid #aaa;
		border-radius: 5px;
		margin-bottom: 6px;
	}


	/* 表格//////// */

	.tab-body {
		background-color: #fff;
	}

	.tab-body:hover {
		cursor: pointer;
		background-color: #e6e6e6;
	}

	.pre_view_tab td {
		/* font-size: 12px; */
	}

	.pre_view_tab td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_view_tab td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.edit-body {
		display: flex;
	}

	.edit-row {
		display: flex;
		width: 100%;
		align-items: flex-start;

	}

	.edit-area {
		display: flex;
		flex-direction: column;
		border-top: 1px solid #bcbcbc;
		padding-top: 6px;
		width: 100%;
	}

	.edit-tab {
		display: flex;
		justify-content: space-evenly;
	}
</style>